export const inspectList = [
  {
    title: "위험작업",
    content: "사고 예방 조치 상태",
    isChecked: "",
  },
  {
    title: "위험작업",
    content: "안전장치 작동/점검 상태",
    isChecked: "",
  },
  {
    title: "위험작업",
    content: "유도원 또는 하부통제인원 배치상태",
    isChecked: "",
  },
  {
    title: "화기작업",
    content: "화기감시자, 소화기구 배치 여부",
    isChecked: "",
  },
  {
    title: "화기작업",
    content: "불티비산방지조치 여부",
    isChecked: "",
  },
  {
    title: "화기작업",
    content: "인화성/가연성 물질 제거 여부",
    isChecked: "",
  },
];
export const inspectListNormal = [
  {
    title: "정리정돈",
    content: "작업공간 구획 여부",
    isChecked: "",
  },
  {
    title: "정리정돈",
    content: "작업공간 주변 정리정돈 상태",
    isChecked: "",
  },
  {
    title: "정리정돈",
    content: "이동 동선 확보 상태",
    isChecked: "",
  },
  {
    title: "보호구",
    content: "근로자 보호구 지급여부",
    isChecked: "",
  },
  {
    title: "보호구",
    content: "근로자 적정 보호구 착용상태",
    isChecked: "",
  },
  // {
  //   title: "눈관리 상태",
  //   content: "각 종 위험표지 상태 등",
  //   isChecked: "",
  // },
  {
    title: "공도구 관련",
    content: "공도구 점검 여부",
    isChecked: "",
  },
  {
    title: "공도구 관련",
    content: "미사용 공도구 전원제거 여부",
    isChecked: "",
  },
  {
    title: "공도구 관련",
    content: "공도구 방호장치 설치 여부",
    isChecked: "",
  },
  {
    title: "시설 관련",
    content: "작업도구 목적 외 사용 여부",
    isChecked: "",
  },
  {
    title: "시설 관련",
    content: "추락 및 낙하 방지조치 여부",
    isChecked: "",
  },
  {
    title: "전기설비 관련",
    content: "가설시설물 변형 및 손상 여부",
    isChecked: "",
  },
  {
    title: "전기설비 관련",
    content: "가설 분전함 시건 및 관리상태",
    isChecked: "",
  },
  {
    title: "전기설비 관련",
    content: "용접기 단자 접지 상태",
    isChecked: "",
  },
  {
    title: "화학물질 관련",
    content: "위험물저장소 관리상태",
    isChecked: "",
  },
  {
    title: "화학물질 관련",
    content: "물질별 MSDS 일치 및 게시 여부",
    isChecked: "",
  },
  {
    title: "화학물질 관련",
    content: "용접용 가스용기 전도방지조치 여부",
    isChecked: "",
  },
  {
    title: "차량계하역운반기계 등",
    content: "화물 등 전도방지 여부",
    isChecked: "",
  },
  {
    title: "차량계하역운반기계 등",
    content: "접촉 및 협착 방지 여부",
    isChecked: "",
  },
  {
    title: "차량계하역운반기계 등",
    content: "이동동선 확보 및 유도원 배치 여부",
    isChecked: "",
  },
  {
    title: "차량계하역운반기계 등",
    content: "과적여부 및 운전자 시야확보 여부",
    isChecked: "",
  },
  {
    title: "지휘감독",
    content: "작업구역 관리감독자 상주 여부",
    isChecked: "",
  },
];
